import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-whatsapp',
  standalone: true,
  templateUrl: '../../assets/whatsapp.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamWhatsappIcon {}
